import { useMutation, useQueryClient } from '@tanstack/react-query';

import { equipmentImagesListKey } from '@components/modals/EditSensorGalleryModal/services/useEquipmentImagesListQuery';

import { hardwareOverviewDetailsKey } from '@pages/HardwareOverviewDetails/services/useHardwareOverviewDetailsQuery';

import { apiClient } from '@services/apiClient';
import { installationPointPhotosKey } from '@services/useInstallationPointPhotosQuery';

interface IParams {
  onSuccess: () => void;
  onError: () => void;
}

interface IData {
  equipmentType: string;
  photoId: number;
}

const equipmentDeletePhotoChangeFn = (data: IData) =>
  apiClient.delete(`${APP_API_URL}${data.equipmentType}/delete-photo/${data.photoId}`);

export const useEquipmentDeletePhotoMutation = ({ onSuccess, onError }: IParams) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: equipmentDeletePhotoChangeFn,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [hardwareOverviewDetailsKey()[0]] });
      queryClient.invalidateQueries({ queryKey: [installationPointPhotosKey()[0]] });
      queryClient.invalidateQueries({ queryKey: [equipmentImagesListKey()[0]] });

      if (onSuccess) onSuccess();
    },
    onError: () => {
      if (onError) onError();
    },
  });
};
